export const getAvailableHeight = (el: HTMLElement): number => {
  if (!el) {
    return 0;
  }
  const rect = el.getBoundingClientRect();

  // nearest scrollable ancestor height (best signal of real viewport for the widget)
  let scrollAncestor: HTMLElement | null = el.parentElement;
  let scrollH = 0;
  while (scrollAncestor && scrollAncestor !== document.body) {
    const { overflowY } = getComputedStyle(scrollAncestor);
    if (/(auto|scroll)/.test(overflowY)) {
      scrollH = scrollAncestor.clientHeight;
      break;
    }
    scrollAncestor = scrollAncestor.parentElement;
  }

  // parent height as a fallback
  const parentH = el.parentElement?.clientHeight ?? 0;

  // viewport from element top (works even if everything is auto)
  const viewportH =
    typeof window !== 'undefined'
      ? Math.max(0, window.innerHeight - rect.top)
      : 0;

  // Take the largest – that’s our “budget”
  return Math.max(scrollH, parentH, viewportH);
};
